/** Result of merging filter-derived and imported profile IDs. */
export interface MergedSelection {
  /** Deduplicated union of both sources; what actually gets associated. */
  finalIds: string[];
  /** How many IDs appeared in both sources (removed by dedup). */
  overlapCount: number;
  /** Size of the deduplicated union. */
  finalTotal: number;
  /** Count of filter-derived IDs (for the "Select profiles" summary line). */
  filterCount: number;
}

/**
 * Merge the filter-derived profile IDs with the imported ones, deduplicating by
 * ID and reporting the overlap. Pure extraction of the `importStats` useMemo
 * that lived in AddList; the three original branches (both / import-only /
 * filter-only) all reduce to this single implementation because the absent
 * source is an empty array.
 */
export function mergeSelection(filterOnlyIds: string[], importedIds: string[]): MergedSelection {
  const merged = new Set([...filterOnlyIds, ...importedIds]);
  return {
    finalIds: Array.from(merged),
    overlapCount: filterOnlyIds.length + importedIds.length - merged.size,
    finalTotal: merged.size,
    filterCount: filterOnlyIds.length,
  };
}
